import TotalProductProfit from "components/Reports/TotalpproductProfit";
import Table from "components/Table";
import DateFilterHeader from "./DateHeaderFilter";

const MyTotalSell = () => {

    return <DateFilterHeader type="productProfit"/>
};

const ProductProfit = () => {
  return  <div className="wrap-journal">
    <Table type="productProfit" MidComponent={MyTotalSell as any}/>
</div>
}
 
export default ProductProfit;